import React from "react"
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material"

// KFC-622: same values as the server's SUPPLIER_ITEM_RECIPES_DETAILS
export const SUPPLIER_ITEM_RECIPES_DETAILS = Object.freeze({
	PRODUCTION_DAY: "productionDay",
	USAGE_DAY: "usageDay"
})

// KFC-622: gross weights of the export per production day, or per production day and day of use of the item
const SupplierItemRecipesDetailRadio = ({ value, onChange }) => (
	<FormControl>
		<FormLabel id="supplier-item-recipes-detail-label">Quantités brutes de l’export</FormLabel>
		<RadioGroup row aria-labelledby="supplier-item-recipes-detail-label" name="detail" value={value} onChange={(event) => onChange(event.target.value)}>
			<FormControlLabel value={SUPPLIER_ITEM_RECIPES_DETAILS.PRODUCTION_DAY} control={<Radio />} label="Par jour de prod" />
			<FormControlLabel value={SUPPLIER_ITEM_RECIPES_DETAILS.USAGE_DAY} control={<Radio />} label="Par jour d’utilisation" />
		</RadioGroup>
		{value === SUPPLIER_ITEM_RECIPES_DETAILS.USAGE_DAY && (
			// mx 0: aligned with the label and the radios, not indented
			<FormHelperText sx={{ mx: 0 }}>Une date d’utilisation peut tomber la veille ou le lendemain de la date de production.</FormHelperText>
		)}
	</FormControl>
)

export default SupplierItemRecipesDetailRadio
